import { gql, useQuery } from "@apollo/client";
import { Flex, Spinner } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import { Login } from "../containers/Login";
import { useSchemaQuery } from "../react-apollo-introspection";
import { authAtom } from "../state/auth";

// const CHECK_AUTH = gql`
//   query CheckAuth {
//     currentAdminUser {
//       user {
//         token
//         isAdmin
//         name
//         email
//         permission_role {
//           permissions {
//             title
//             code
//           }
//         }
//       }
//       isAdmin
//     }
//   }
// `;
const Loading = () => (
  <Flex w="100vw" h="100vh" align="center" justify="center">
    <Spinner />
  </Flex>
);
const AuthProvider = ({ children }) => {
  const [checkAuth, { data, loading, error }] = useSchemaQuery(
    "adminuser_Current"
  );
  const [auth, setAuth] = useRecoilState(authAtom);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    checkAuth();
  }, []);

  useEffect(() => {
    if (data && data.adminuser_Current) {
      setAuth(data.adminuser_Current);
    }
  }, [data, setAuth]);

  if (loading) {
    return <Loading />;
  }
  if (!auth && error && location.pathname !== "/login" && location.pathname !== "/reset-password") {
    navigate("/login");
    return <Loading />;
  } else if (
    auth &&
    (location.pathname === "/" || location.pathname === "/login")
  ) {
    navigate("/places");
    return <Loading />;
  }

  return <div>{children}</div>;
};

export default AuthProvider;
